import React, { createContext, useContext, useState, useEffect } from "react";
import { GetUserProfile } from "../../services/backendServices";
import { STORAGE_KEYS } from "../../Util/key_helper";
// Create a context for ProfileData
const ProfileContext = createContext();
/*** ProfileContextProvider: A provider component to manage and supply profile data*/
export const ProfileContextProvider = ({ children }) => {
    const [profileData, setProfileData] = useState(() => {
        const storedPermissions = localStorage.getItem(STORAGE_KEYS.USER_PERMISSION);
        return storedPermissions ? JSON.parse(storedPermissions) : null;
    });
    const [profileLoading, setProfileLoading] = useState(true);; // State to track profileLoading status for profile data 
    const [refetchProfileData, setRefetchProfileData] = useState(true);  // state to track profile data has been fetched

    // Function to fetch user profile
    const fetchUserProfile = async () => {
        try {
            const res = await GetUserProfile();
            if (res.status) {
                setProfileData(res.data);
                const minimalPermissions = {
                    can_add_demat: res.data.can_add_demat,
                    ip_purchase_permit: res.data.ip_purchase_permit,
                    tool_permit: res.data.tool_permit,
                    is_tool_free: res?.data?.is_tool_free,
                    has_tools_subscription: res?.data?.has_tools_subscription,
                    is_tool_demo_used: res?.data?.is_tool_demo_used,

                };
                localStorage.setItem(STORAGE_KEYS.USER_PERMISSION,
                    JSON.stringify(minimalPermissions)
                );
                setRefetchProfileData(false)
            }
        } catch (error) {
            console.error("Error fetching user profile", error);
        } finally {
            setProfileLoading(false);
        }
    };
    useEffect(() => {
        const storedPermissions = localStorage.getItem(STORAGE_KEYS.USER_PERMISSION);
        if (storedPermissions) {
            // Merge stored permissions into profileData if available
            setProfileData((prev) => ({ ...prev, ...JSON.parse(storedPermissions) }));
        }
    }, []);

    useEffect(() => {
        if (refetchProfileData) {
            fetchUserProfile();
        }
    }, [refetchProfileData])
    return (
        // The ProfileContext.Provider component provides state and functions to the children components
        <ProfileContext.Provider
            value={{
                profileData, // provides  the user profile data 
                setProfileData, // Provides the function to set/update the profile data
                profileLoading,// Provides the loading state of profile data 
                fetchUserProfile,   // Provides the function to fetch the user profile data
                setRefetchProfileData, //Provides a function to manually update the fetched status
                refetchProfileData, // provides the fetched status of profile data 
            }}>
            {children}
        </ProfileContext.Provider>
    );
};

// Custom hook to use the UserProfileContext
export const UseProfileContext = () => useContext(ProfileContext);
